<style scoped>
table {
  width: 99.5%;
}
i.circle {
  width: 25px;
  height: 25px;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  display: block;
  float: left;
  margin-right: 10px;
}
tr:nth-child(odd) {
  background: #f6f6f6;
}
</style>

<template>
  <v-layout>
    <v-flex xs12>
      <v-alert
        v-if="alert"
        :value="!loading"
        :type="alert.type"
        v-html="alert.message"
      ></v-alert>
      <v-data-table
        class="elevation-1 full-size-table tableData-size"
        :headers="headers"
        :loading="loading"
        :items="getItems"
        hide-actions
        must-sort
      >
        <template v-slot:items="{ item }">
          <tr>
            <td>{{ item.position }}</td>
            <td>{{ item.materialNo }}</td>
            <td>{{ item.description }}</td>
            <td align="right">
              <v-flex xs7>
                <v-text-field
                  v-if="mutable"
                  :value="item.quantity"
                  @input="onQuantityChange(item, $event)"
                  type="number"
                  min="1"
                ></v-text-field>
                <span v-else>{{ item.quantity }}</span>
              </v-flex>
            </td>
            <td v-if="showPrice" align="right">
              {{ item.lineAmount }}
            </td>
            <td v-if="!mutable && displayMaterialAvailability">
              <availability-status-indicator
                :orderQuantity="item.quantity"
                :confirmedQuantity="item.confirmedQuantity"
              ></availability-status-indicator>
            </td>
            <td v-if="mutable">
              <v-icon @click="onDeleteItem(item.id)">delete</v-icon>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          <div v-if="loading" style="text-align: center;">Please wait</div>
          <v-alert v-else color="secondary" type="warning" :value="true">
            Your basket contains no items
          </v-alert>
        </template>
        <template v-slot:footer>
          <tr v-if="!mutable">
            <td :colspan="headers.length">
              <v-alert
                v-if="alert"
                :value="!loading"
                :type="alert.type"
                v-html="alert.message"
              ></v-alert>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import AvailabilityStatusIndicator from "@/components/AvailabilityStatusIndicator";

export default {
  components: {
    AvailabilityStatusIndicator
  },
  props: {
    mutable: Boolean
  },
  computed: {
    ...mapGetters("basket", ["getItems"]),
    ...mapState("basket", [
      "alert",
      "loading",
      "documentCurrency",
      "displayMaterialAvailability"
    ]),
    headers() {
      const headers = [
        {
          text: "Position",
          value: "position"
        },
        {
          text: "Material No.",
          value: "materialNo"
        },
        {
          text: "Description",
          value: "description"
        },
        {
          text: "Quantity",
          value: "quantity",
          align: "right"
        }
      ];
      if (this.showPrice) {
        headers.push({
          text: "Line Amount " + this.documentCurrency,
          sortable: false,
          align: "right"
        });
      }
      if (this.mutable) {
        headers.push({
          text: "Remove",
          sortable: false
        });
      }
      if (!this.mutable && this.displayMaterialAvailability) {
        headers.push({
          text: "Availability",
          sortable: false
        });
      }
      return headers;
    },
    showPrice() {
      return !this.mutable && this.$store.getters["customer/canSeePrice"];
    }
  },
  methods: {
    onDeleteItem(id) {
      this.$store.dispatch("basket/removeFromBasket", id);
    },
    onQuantityChange(item, event) {
      const quantity = Number.parseInt(event, 10) || 0;
      this.$store.dispatch("basket/changeItemQuantity", {
        id: item.id,
        quantity
      });
    }
  }
};
</script>
